import { z } from "zod";

import { BannerLevel } from "~frontend/__generated__/graphql";

const ALL_SENTINEL = "__all__";

export const BannerFormSchema = z
  .object({
    tenantIds: z.array(z.string()),
    subaccountIds: z.array(z.string()),
    level: z.nativeEnum(BannerLevel, {
      required_error: "Banner type is required",
    }),
    message: z
      .string()
      .min(1, "Message is required")
      .max(500, "Message must be 500 characters or less"),
    link: z.string().url("Must be a valid URL").optional().or(z.literal("")),
    linkText: z.string().max(30, "Link text must be 30 characters or less"),
    startsAt: z
      .string({ message: "Start time required." })
      .datetime("Start date must be a valid date and time"),
    expiresAt: z.string().datetime().nullish(),
  })
  .superRefine((data, ctx) => {
    // Validate that link and linkText are both provided or both empty
    const hasLink = data.link && data.link.trim() !== "";
    const hasLinkText = data.linkText && data.linkText.trim() !== "";
    if (hasLink && !hasLinkText) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Link text is required when link is provided",
        path: ["linkText"],
      });
    }

    if (hasLinkText && !hasLink) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Link is required when link text is provided",
        path: ["link"],
      });
    }

    if (data.expiresAt && data.expiresAt < data.startsAt) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "End must be after start",
        path: ["expiresAt"],
      });
    }

    return true;
  });

export type BannerFormValues = z.infer<typeof BannerFormSchema>;

export { ALL_SENTINEL };
